import jwtDecode from 'jwt-decode';

export interface DecodedToken {
  sub: string;
  userId: number;
  userName: string;
  authorities: string[];
  institutionId?: number;
  iat: number;
  exp: number;
}

export const getDecodedToken = (): DecodedToken | null => {
  const token = localStorage.getItem('loginToken');
  if (!token) return null;
  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    console.error('JWT decode failed', error);
    return null;
  }
};
